import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import './Eyebrow.scss';

const Eyebrow = (props) => {
  const {
    content,
    isGda,
  } = props;

  if (!content) return null;

  return (
    <div className={cx('Eyebrow', { 'Eyebrow--gda': isGda })}>
      {content}
    </div>
  );
};

Eyebrow.propTypes = {
  content: PropTypes.string.isRequired,
  isGda: PropTypes.bool,
};

Eyebrow.defaultProps = {
  isGda: false,
};

Eyebrow.displayName = 'Eyebrow';
export default Eyebrow;
